// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCard_root__1_JEa"};